export const DELIMITER = ':';

export const DEFAULT_UNSELECTED_INDEX = -1;

export const START_CREATED_TIME_KEY = 'startCreatedTime';

export const END_CREATED_TIME_KEY = 'endCreatedTime';
